import React from 'react';
import { View } from 'react-native';
import { useTheme } from 'react-native-paper';

import { CircularNumber } from '../../molecules/circular-number/circular-number';
import { flex, ml, mv, width } from '../../style-utils';
import { OEText } from '../oe-text/oe-text';
export interface ItemNumberedProps {
  title?: string;
  description?: string | React.ReactElement;
  theme?: 'default' | 'light';
  number: number;
  numberBold?: boolean;
}

export const ItemNumbered = ({
  theme = 'default',
  title,
  description,
  number,
  numberBold = false,
}: ItemNumberedProps) => {
  const { colors } = useTheme();

  const fontColor = theme === 'default' ? colors.white : colors.primary;
  const backgroundColor =
    theme === 'default' ? colors.primary : colors.backgroundOeBlue20;
  const radius = theme === 'default' ? 34 : 32;
  return (
    <View style={[flex('flex-row'), width('100%'), mv(12)]}>
      <CircularNumber
        fontColor={fontColor}
        backgroundColor={backgroundColor}
        number={number}
        radius={radius}
        bold={numberBold}
      />
      <View style={[flex('flex-shrink-1'), ml(24)]}>
        {!!title && (
          <OEText fontType="medium" fontSize={16}>
            {title}
          </OEText>
        )}
        {!!description && (
          <OEText fontSize={16} style={flex('flex-wrap')}>
            {description}
          </OEText>
        )}
      </View>
    </View>
  );
};
